module.exports = __webpack_public_path__ + "static/media/productfeaturevisualization.5b99a434.png";